const getUtmTags = () => {
  const utmTags: { [key: string]: string } = {};

  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    // Attempt to get the entire 'utmData' object from localStorage
    const storedUtmData = localStorage.getItem('utmData');
    if (storedUtmData) {
      // Parse the entire utmData object if available
      try {
        const parsedUtmData = JSON.parse(storedUtmData);
        Object.assign(utmTags, parsedUtmData); // Merge parsed data into utmTags
      } catch (error) {
        console.error('Error parsing utmData from localStorage', error);
      }
    }

    // Retrieve individual UTM parameters if they're not part of 'utmData'
    const utmParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'gclid',
      'gad_source',
    ];

    // Check each UTM parameter individually from localStorage
    utmParams.forEach((param) => {
      const value = localStorage.getItem(param);
      if (value) {
        utmTags[param] = value;
      }
    });
  }

  return utmTags;
};

export default getUtmTags;
